import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class QualityReferenceService extends BaseReferenceService {
  constructor() {
    super('QualityReference');
  }
}
